import { gql } from "@apollo/client";
import { SALES_BRIEF_WINDOW_TYPES } from "./constants";

const SALES_BRIEF_FIELDS = `
  snapshotId
  status
  generatedAt
  aiBrief {
    headline
    executiveSummary
    schemaVersion
    model
    promptVersion
    whatChanged
    whyChanged
    suggestedActions {
      entityType
      entityId
      entityDisplayName
      expectedImpact
      reason
      suggestion
    }
    openQuestions
    kpiFocus {
      currentValue
      targetValue
      unit
      targetHorizon
      whyItMatters
      metricKey
    }
    confidence {
      score
      notes
    }
    generatedAt
  }
  window {
    windowType
    label
    currentStart
    currentEnd
    previousStart
    previousEnd
    dateBasis
  }
  summary {
    headlineText
    totalSales {
      current
      previous
      delta
      deltaPct
    }
    orderCount {
      current
      previous
      delta
      deltaPct
    }
    activeCustomers {
      current
      previous
      delta
      deltaPct
    }
    avgOrderValue {
      current
      previous
      delta
      deltaPct
    }
    atRiskRevenue
    recoverableRevenue
  }
  topDownDrivers {
    rank
    driverId
    driverType
    entityId
    entityDisplayName
    metric
    current
    previous
    delta
    deltaPct
    contributionPct
    evidence {
      currentOrderCount
      previousOrderCount
      currentAvgOrderValue
      previousAvgOrderValue
    }
  }
  topUpDrivers {
    rank
    driverId
    driverType
    entityId
    entityDisplayName
    metric
    current
    previous
    delta
    deltaPct
    contributionPct
    evidence {
      currentOrderCount
      previousOrderCount
      currentAvgOrderValue
      previousAvgOrderValue
    }
  }
  diagnoses {
    diagnosisId
    linkedDriverId
    entityType
    entityId
    entityDisplayName
    severity
    title
    summary
    signals
    disproofQuestion
  }
  riskWatchlist {
    itemId
    entityDisplayName
    level
    signal
    currentRevenue
    previousRevenue
    currentOrderCount
    previousOrderCount
    nextBestActionHint
  }
  opportunityWatchlist {
    itemId
    entityDisplayName
    level
    signal
    currentRevenue
    previousRevenue
    currentOrderCount
    previousOrderCount
    nextBestActionHint
  }
`;

export const FETCH_AI_SALES_BRIEF = gql`
  query {
    aiSalesBrief {
      ${SALES_BRIEF_FIELDS}
    }
  }
`;

export const FETCH_AI_SALES_BRIEF_BY_WINDOW_TYPE = Object.fromEntries(
  SALES_BRIEF_WINDOW_TYPES.map(([windowType]) => [
    windowType,
    gql`
      query {
        aiSalesBrief(windowType: ${windowType}) {
          ${SALES_BRIEF_FIELDS}
        }
      }
    `,
  ]),
);
